/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Integration deployment request
 * @export
 * @interface IntegrationDeploymentRequest
 */
export interface IntegrationDeploymentRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationDeploymentRequest
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationDeploymentRequest
     */
    instanceName?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IntegrationDeploymentRequest
     */
    _configuration?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof IntegrationDeploymentRequest
     */
    scheduleId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IntegrationDeploymentRequest
     */
    outboundConfig?: { [key: string]: any; };
}

/**
 * Check if a given object implements the IntegrationDeploymentRequest interface.
 */
export function instanceOfIntegrationDeploymentRequest(value: object): value is IntegrationDeploymentRequest {
    return true;
}

export function IntegrationDeploymentRequestFromJSON(json: any): IntegrationDeploymentRequest {
    return IntegrationDeploymentRequestFromJSONTyped(json, false);
}

export function IntegrationDeploymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationDeploymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'instanceName': json['instanceName'] == null ? undefined : json['instanceName'],
        '_configuration': json['configuration'] == null ? undefined : json['configuration'],
        'scheduleId': json['scheduleId'] == null ? undefined : json['scheduleId'],
        'outboundConfig': json['outboundConfig'] == null ? undefined : json['outboundConfig'],
    };
}

export function IntegrationDeploymentRequestToJSON(json: any): IntegrationDeploymentRequest {
    return IntegrationDeploymentRequestToJSONTyped(json, false);
}

export function IntegrationDeploymentRequestToJSONTyped(value?: IntegrationDeploymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationId': value['integrationId'],
        'instanceName': value['instanceName'],
        'configuration': value['_configuration'],
        'scheduleId': value['scheduleId'],
        'outboundConfig': value['outboundConfig'],
    };
}

